import React from 'react'
import _ from 'lodash'
import queryString from 'query-string'

const withParams = WrappedComponent => {
  return class ParamMapping extends React.Component {

    render() {
      const params = {
        ...queryString.parse(this.props.location.search),
        ...this.props.match.params,
        ...this.props.location.state
      }

      return <WrappedComponent {...this.props} params={params} />
    }
  }
}

export default withParams



// WEBPACK FOOTER //
// ./src/modules/router-manage/withParams.js